import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Zap, Users, Calendar, FolderOpen, Eye, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function MentorQuickActionsWidget() {
  const navigate = useNavigate();

  const actions = [
    { label: "My Mentees", icon: Users, path: "/new-teacher-mentor-program" },
    { label: "Meetings", icon: Calendar, path: "/meeting-tracker" },
    { label: "Resources", icon: FolderOpen, path: "/resources" },
    { label: "Observations", icon: Eye, path: "/putting-it-into-practice" },
    { label: "Reports", icon: BarChart3, path: "/mentoring-reports" },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Zap className="h-5 w-5" />
          Quick Actions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-2">
          {actions.map((action) => (
            <Button
              key={action.path}
              variant="outline"
              size="sm"
              className="justify-start text-xs h-9 whitespace-nowrap"
              onClick={() => navigate(action.path)}
            >
              <action.icon className="h-4 w-4 mr-1.5 flex-shrink-0" />
              <span className="truncate">{action.label}</span>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
